<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div :class="type === 'info' ? 'modal-container-info' : 'modal-container'">
          <i class="modal-icon fa fa-exclamation-circle"></i>
          <p class="modal-header">{{ title }}</p>
          <p class="modal-body">
            <small>
              <div v-html="body"></div>
              <span v-if="redirect">Para ser redirecionado, 
                <span class="redirect" @click.prevent="redirectToFlight">
                  clique aqui.
                </span>
              </span>
            </small>
          </p>
          <button class="close" @click.prevent="closeModal"></button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  props: ['title', 'body', 'type', 'redirect'],
  methods: {
    redirectToFlight: function () {
      this.$router.push({name: 'flight'});
    },
    closeModal: function () {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/variables";

.redirect {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.confirm-btn {
  background-color: white;
  color: #046cb1;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container {
      position: relative;
      max-width: 550px;
      margin: 0px auto;
      padding: 1em;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, .3);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
      //background: #fafafa;

      background: rgba(184,83,85,1);
      background: -moz-linear-gradient(top, rgba(184,83,85,1) 0%, rgba(171,74,77,1) 100%);
      background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(184,83,85,1)), color-stop(100%, rgba(171,74,77,1)));
      background: -webkit-linear-gradient(top, rgba(184,83,85,1) 0%, rgba(171,74,77,1) 100%);
      background: -o-linear-gradient(top, rgba(184,83,85,1) 0%, rgba(171,74,77,1) 100%);
      background: -ms-linear-gradient(top, rgba(184,83,85,1) 0%, rgba(171,74,77,1) 100%);
      background: linear-gradient(to bottom, rgba(184,83,85,1) 0%, rgba(171,74,77,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b85355', endColorstr='#ab4a4d', GradientType=0 );

      &:after {
        @include inverted-triangle($color: rgba(#fff, .1));
        //@include inverted-triangle($color: $warning-color);
      }

      .modal-icon {
        @include slideRight();
        position: absolute;
        left: 1rem;
        font-size: 1.5rem;
        @media (min-width: 535px) {     
          left: 1.5rem;
          font-size: 2.5rem;
        }                
        top: 1rem;
        color: #fff;
        //color: $warning-color;
        opacity: .5;
        margin: 0;
        line-height: 1;
        display: inline-block;                
      }

      .modal-header, .modal-body {
        display: inline-block;
        margin: 0 0 0 2.5rem;
        @media (min-width: 535px) {     
          margin: 0 0 0 4rem;
        }                 
        color: #fff;
        //color:$secondary-text-color;
      }

      .modal-header {
        //color: darken($warning-color, 8%);
        //font-weight: 700;
        margin-bottom: 0;
        font-size: 1rem;
      }

      p.modal-body {
        @include comeRight();
        color: #fff;
        display: block;
        margin-bottom: 0;
        margin-right: 2rem;
        opacity: .6;
        line-height: 1.3;

        small {
          line-height: inherit;
        }
      }

      button.close {
        position: absolute;
        opacity: .5;
        top: 1em;
        background: #fff;
        //background-color: $warning-color;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        right: 1em;
        min-width: 1em;
        transition: transform 0.5s cubic-bezier(.16,.81,.32,1), opacity 0.5s ease;                

        &:hover {
          background-color: #fff;
          //background-color: $warning-color;
          opacity: 1;
          -webkit-transform: rotate(90deg);
          transform: rotate(180deg);
        }

        &:after {
          content: "x";
          display: block;
          top: 0;
          font-size: .5em;
          font-weight: 700;
          line-height: .5;
          color: rgba(184,83,85,1);
          //color: #fff;
        }
      }
    }

    .modal-container-info {
      position: relative;
      max-width: 550px;
      margin: 0px auto;
      padding: 1em;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, .3);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
      //background: #fafafa;

      background: rgba(0,58,96,1);
      background: -moz-linear-gradient(top, rgba(0,58,96,1) 0%, rgba(4,108,177,1) 100%);
      background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(0,58,96,1)), color-stop(100%, rgba(4,108,177,1)));
      background: -webkit-linear-gradient(top, rgba(0,58,96,1) 0%, rgba(4,108,177,1) 100%);
      background: -o-linear-gradient(top, rgba(0,58,96,1) 0%, rgba(4,108,177,1) 100%);
      background: -ms-linear-gradient(top, rgba(0,58,96,1) 0%, rgba(4,108,177,1) 100%);
      background: linear-gradient(to bottom, rgba(0,58,96,1) 0%, rgba(4,108,177,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b85355', endColorstr='#ab4a4d', GradientType=0 );

      &:after {
        @include inverted-triangle($color: rgba(#fff, .1));
        //@include inverted-triangle($color: $warning-color);
      }

      .modal-icon {
        @include slideRight();
        position: absolute;
        left: 1rem;
        font-size: 1.5rem;
        @media (min-width: 535px) {     
          left: 1.5rem;
          font-size: 2.5rem;
        }                
        top: 1rem;
        color: #fff;
        //color: $warning-color;
        opacity: .5;
        margin: 0;
        line-height: 1;
        display: inline-block;                
      }

      .modal-header, .modal-body {
        display: inline-block;
        margin: 0 0 0 2.5rem;
        @media (min-width: 535px) {     
          margin: 0 0 0 4rem;
        }                 
        color: #fff;
        //color:$secondary-text-color;
      }

      .modal-header {
        //color: darken($warning-color, 8%);
        //font-weight: 700;
        margin-bottom: 0;
        font-size: 1rem;
      }

      p.modal-body {
        @include comeRight();
        color: #fff;
        display: block;
        margin-bottom: 0;
        margin-right: 2rem;
        opacity: .6;
        line-height: 1.3;

        small {
          line-height: inherit;
        }
      }

      button.close {
        position: absolute;
        opacity: .5;
        top: 1em;
        background: #fff;
        //background-color: $warning-color;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        right: 1em;
        min-width: 1em;
        transition: transform 0.5s cubic-bezier(.16,.81,.32,1), opacity 0.5s ease;                

        &:hover {
          background-color: #fff;
          //background-color: $warning-color;
          opacity: 1;
          -webkit-transform: rotate(90deg);
          transform: rotate(180deg);
        }

        &:after {
          content: "x";
          display: block;
          top: 0;
          font-size: .5em;
          font-weight: 700;
          line-height: .5;
          color: rgba(0,63,104,1);
          //color: #fff;
        }
      }
    }
  }    
}

</style>





// WEBPACK FOOTER //
// src/components/shared/Modal.vue